import api from '../api/api-list'

const state = {
  userData: {},
  buyMemeberData: {},
  upFile: '',
  isUpdate: true,//求职意向是否进入编辑
  isNeedResume: false,//是否需要跳转到设置简历
  isOnlineCv: false, // 求职意向是否跳转到在线简历预览页
  userIntention: {},//用户意向
  showUserDialog: false,
  showUserDialogText:"",
  isNewUser: false, // 是否为新用户
  cacheSelectedDegree: [],// 新用户所选择的学历
  cacheUserIdentity: '', // 新用户所选择的身份
  cacheSelectedSchool: {}, // 新用户所选择的学校
  cacheSelectedYear: '', // 新用户所选择的毕业年份
}

const actions = {
  // 获取用户账户信息
  getUserAccountInfo: async function ({commit}, token) {
    try {
      let res = await api.user.getUserAccountInfo(token)
      if (res.code === 1000) {
        commit('changeUserData', res.data)
      }
    } catch (e) {
      console.log(e)
    }
  },

  setUpFile({commit}, data) {
    commit('setUpFile', data)
  },
  //更新求职状态
  getUserIntention: async function ({commit}, params) {
    try {
      let intention = await api.intention.getIntentionNew()
      commit('setUserIntention', intention.data)
    } catch (error) {
      console.log(error)
    }
  },
  getShowUserDialog:async  ({ commit, state }, token) => {
    try {
      let [user, identity] = await Promise.all([api.community.checkUserName(token), api.community.getCommunityInfo(token)])
      let userIdentity = {nickName: false, identity: false}
      if(user.code === 1000){
        userIdentity.nickName = !user.data.username_null
      }
      if(identity.code === 1000){
        userIdentity.identity = !!identity.data.stu_community_prefix || !!identity.data.stu_community_suffix || !!identity.data.com_community_prefix || !!identity.data.com_community_suffix
      }
      if(!userIdentity.nickName || !userIdentity.identity){
        if(!userIdentity.nickName && userIdentity.identity){
          commit("setShowUserDialogText","社区昵称")
        }else if(userIdentity.nickName && !userIdentity.identity){
          commit("setShowUserDialogText","社群身份")
        } else if(!userIdentity.nickName && !userIdentity.identity){
          commit("setShowUserDialogText","社区昵称和身份")
        }
        commit('setShowUserDialog',true)
      }
    } catch (e) {
      console.log(e)
    }
  }
}

const getters = {}

const mutations = {
  setUpFile(state, data) {
    state.upFile = data
  },
  getBuyMemberData(state, buyMemeberData) {
    state.buyMemeberData = buyMemeberData
  },
  changeUserData(state, data) {
    state.userData = data
  },
  setIsUpdate(state, data) {
    state.isUpdate = data
  },
  setIsNeedResume(state, data) {
    state.isNeedResume = data
  },
  setIsOnlineCv(state, data) {
    state.isOnlineCv = data
  },
  setUserIntention(state, data) {
    state.userIntention = data
  },
  setShowUserDialog (state, value) {
    state.showUserDialog = value
  },
  setShowUserDialogText (state, value) {
    state.showUserDialogText = value
  },
  cacheNewUserInfo(state, value) {
    if (value) {
      state.isNewUser = true;
      state.cacheSelectedDegree = value.degree;// 新用户所选择的学历
      state.cacheUserIdentity = value.identity; // 新用户所选择的身份
      state.cacheSelectedSchool = value.school; // 新用户所选择的学校
      state.cacheSelectedYear = value.year; // 新用户所选择的毕业年份
    }
  },
  clearNewUserInfo(state) {
    state.isNewUser = false;
    state.cacheSelectedDegree = [];// 新用户所选择的学历
    state.cacheUserIdentity = ''; // 新用户所选择的身份
    state.cacheSelectedSchool = {}; // 新用户所选择的学校
    state.cacheSelectedYear = ''; // 新用户所选择的毕业年份
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
